import React, { useState, useEffect } from 'react';

// Service options with labels and icons
const SERVICE_OPTIONS = [
  { key: 'accepts_cash', label: 'Cash', icon: '💵', category: 'Payment' },
  { key: 'accepts_card', label: 'Card', icon: '💳', category: 'Payment' },
  { key: 'accepts_mobile_payment', label: 'Mobile Pay', icon: '📱', category: 'Payment' },
  { key: 'offers_catering', label: 'Catering', icon: '🎉', category: 'Services' },
  { key: 'online_ordering', label: 'Online Ordering', icon: '🛒', category: 'Services' },
  { key: 'delivery_available', label: 'Delivery', icon: '🚗', category: 'Services' },
  { key: 'vegetarian_options', label: 'Vegetarian', icon: '🥗', category: 'Dietary' },
  { key: 'vegan_options', label: 'Vegan', icon: '🌱', category: 'Dietary' },
  { key: 'gluten_free_options', label: 'Gluten-Free', icon: '🌾', category: 'Dietary' },
];

// Group services by category
const groupedServices = SERVICE_OPTIONS.reduce((acc, service) => {
  if (!acc[service.category]) {
    acc[service.category] = [];
  }
  acc[service.category].push(service);
  return acc;
}, {});

function OnboardingModal({ currentServices, onSave, onClose, isNewUser = false }) {
  const [services, setServices] = useState({
    accepts_cash: false,
    accepts_card: false,
    accepts_mobile_payment: false,
    offers_catering: false,
    vegetarian_options: false,
    vegan_options: false,
    gluten_free_options: false,
    online_ordering: false,
    delivery_available: false,
  });
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (currentServices) {
      setServices(prev => ({ ...prev, ...currentServices }));
    }
  }, [currentServices]);

  const handleToggle = (key) => {
    setServices(prev => ({ ...prev, [key]: !prev[key] }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    try {
      await onSave(services);
      onClose();
    } catch (err) {
      console.error('Failed to save services:', err);
      alert('Failed to save services. Please try again.');
    }
    setIsSaving(false);
  };

  const handleSkip = () => {
    onClose();
  };

  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="auth-modal onboarding-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-modal-wrapper">
          <button className="close-btn" onClick={onClose}>×</button>
          
          <h2>{isNewUser ? '🚚 Welcome! Set Up Your Services' : '⚙️ Update Your Services'}</h2>
          
          {isNewUser && (
            <p className="onboarding-intro">
              Help customers find you! Select the services and options your food truck offers.
            </p>
          )}

          <form onSubmit={handleSubmit}>
            {Object.entries(groupedServices).map(([category, categoryServices]) => (
              <div key={category} className="service-category">
                <h3 className="category-title">{category}</h3>
                <div className="service-options">
                  {categoryServices.map(service => (
                    <label 
                      key={service.key} 
                      className={`service-option ${services[service.key] ? 'selected' : ''}`}
                    >
                      <input
                        type="checkbox"
                        checked={services[service.key]}
                        onChange={() => handleToggle(service.key)}
                      />
                      <span className="service-icon">{service.icon}</span>
                      <span className="service-label">{service.label}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            <div className="onboarding-actions">
              <button 
                type="submit" 
                className="auth-button primary"
                disabled={isSaving}
              >
                {isSaving ? 'Saving...' : 'Save Services'}
              </button>
              {isNewUser && (
                <button 
                  type="button" 
                  className="auth-button secondary"
                  onClick={handleSkip}
                >
                  Skip for Now
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// Export the service options for use in other components
export { SERVICE_OPTIONS };
export default OnboardingModal;
